<template>
  <div>
    <ViewHeader title="Périodes" />
    <div v-if="quartersList?.length">
      <CardDropdownList
        :init-show-dropdown="true"
        :quarter-list-in-rows="openQuarters"
        dropdown-label="Période en cours"
        class="my-6"
      />
      <CardDropdownList
        :init-show-dropdown="false"
        :quarter-list-in-rows="closedQuarters"
        dropdown-label="Périodes cloturées"
        class="my-6"
      />
    </div>
    <DotsLoader v-else></DotsLoader>
  </div>
</template>

<script>
import CardDropdownList from "@/components/CardDropdownList";
import { ClosingFileService } from "@/services/closing_file";

export default {
  name: "QuarterList",
  components: { CardDropdownList },
  data() {
    return {
      quartersList: [],
      rowLength: 4,
    };
  },
  computed: {
    closedQuarters() {
      const closedQuarters = this.quartersList.filter(
        (quarter) => !quarter.is_active
      );
      return this.createQuarterDisplayRows(closedQuarters);
    },
    openQuarters() {
      const openQuarters = this.quartersList.filter(
        (quarter) => quarter.is_active
      );
      return this.createQuarterDisplayRows(openQuarters);
    },
  },
  async mounted() {
    this.quartersList = await ClosingFileService.getQuarters();
  },
  methods: {
    createQuarterDisplayRows(quartersList) {
      const rows = [];
      for (let i = 0; i < quartersList.length; i += this.rowLength) {
        rows.push(quartersList.slice(i, i + this.rowLength));
      }
      return rows;
    },
  },
};
</script>
